import { combineReducers } from "redux";

import auth from "./auth/reducer";
import history from "./history/reducer";
import calculator from "./calculator/reducer";
import dashboard from "./dashboard/reducer";
import accountInfo from "./accountInfo/reducer";
import fundPrices from "./fundPrices/reducer";
import nextOfKin from "./nextOfKin/reducer";
import employerDetails from "./employerDetails/reducer";
import contactUs from "./contactUs/reducer";
import faq from "./faq/reducer";
import downloadForms from "./downloadForms/reducer";
import privacyPolicy from "./privacyPolicy/reducer";
import consent from "./consent/reducer";
import onboarding from "./onboarding/reducer";
import rsaPinRegistration from "./rsaPinRegistration/reducer";
import staffDashboard from "./staffDashboard/reducer";
import employerDashboard from "./employerDashboard/reducer";
import agentDashboard from "./agentDashboard/reducer";
import statementGeneration from "./statementGeneration/reducer";
import referral from "./referral/reducer";
import rewardSystem from "./rewardSystem/reducer";
import scheduleSubmissionReport from "./scheduleSubmissionReport/reducer";
import outputScreen from "./outputScreen/reducer";
import requestEmployerCode from "./requestEmployerCode/reducer";
import rsaPinDublicated from "./rsaPinDublicated/reducer";
import rsaNINImplementation from "./rsaNINImplementation/reducer";
import microPensionDublicated from "./microPensionDublicated/reducer";
import mpNINImplementation from "./mpNINImplementation/reducer";
import activationOptionModal from "./activationOptionModal/reducer";
import bannerPopup from "./bannerPopup/reducer";

export default combineReducers({
  auth,
  history,
  calculator,
  bannerPopup,
  dashboard,
  accountInfo,
  fundPrices,
  nextOfKin,
  employerDetails,
  contactUs,
  faq,
  downloadForms,
  privacyPolicy,
  consent,
  onboarding,
  staffDashboard,
  employerDashboard,
  agentDashboard,
  rsaPinRegistration,
  statementGeneration,
  referral,
  rewardSystem,
  scheduleSubmissionReport,
  outputScreen,
  requestEmployerCode,
  rsaPinDublicated,
  microPensionDublicated,
  rsaNINImplementation,
  mpNINImplementation,
  activationOptionModal,
});
